module.exports = __webpack_public_path__ + "assets/img/title-6c454bc0.png";